import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  changeTimeRange,
  setDateRangeOption,
  resetDateRangeOption,
} from './../reducer';
import { Translate } from 'react-redux-i18n';
import Const from './Const';
import React from 'react';
import PopupCalendar from './PopupCalendar';
import TimeZoneHandle from '../../../common/timezone-handle/index';
import TimeRangeWrapper from '../../../common/time-range-wrapper';
import './../index.scss';

const language = {
  vi: 'vi',
  en: 'en',
};

class FilterTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilted: false,
      startDate: null,
      endDate: null,
    };
  }

  resetDateRangeFilter = () => {
    const { resetDateRangeOption } = this.props;
    resetDateRangeOption();
  };

  format = inputDate => {
    const { i18n } = this.props;
    const date = new Date(inputDate);
    return (
      <TimeZoneHandle
        time={date}
        format={i18n.locale === language.en ? 'MM/DD/YYYY' : 'DD/MM/YYYY'}
      />
    );
  };

  renderInfoFilterDayRange = () => {
    const { timeRangeFilter, dateRangeOption } = this.props;
    if (
      !timeRangeFilter &&
      dateRangeOption.FromDate &&
      dateRangeOption.ToDate
    ) {
      return (
        <TimeRangeWrapper onClickCloseButton={this.resetDateRangeFilter}>
          <div className="time-range-carlendar d-flex">
            <span className="text-carlendar-filter mb-10">
              {<Translate value={`marketCalendarCorporate.timeRange`} />} :{' '}
              <a style={{ color: 'gray' }}>
                {
                  <Translate
                    value={`marketCalendarCorporate.timeRangeFilter.from`}
                  />
                }
              </a>{' '}
              {this.format(dateRangeOption.FromDate)}{' '}
              <a style={{ color: 'gray' }}>
                {' '}
                {
                  <Translate
                    value={`marketCalendarCorporate.timeRangeFilter.to`}
                  />
                }{' '}
              </a>{' '}
              {this.format(dateRangeOption.ToDate)}
            </span>
          </div>
        </TimeRangeWrapper>
      );
    } else {
      return (
        <span className="text-carlendar-filter">
          <a />
        </span>
      );
    }
  };

  renderLeftFilterDayRange = () => {
    const {
      timeRangeFilter,
      currentFilterEvents,
      changeTimeRange,
    } = this.props;
    let listTimeRange = Const.listTimeRange;
    let listTimeRangeByKey = Const.listTimeRangeByKey;

    if (currentFilterEvents === Const.listFilterEventByKey.ern.key) {
      listTimeRange = Const.listTimeRangeErn;
      listTimeRangeByKey = Const.listTimeRangeErnByKey;
    }

    return (
      <div className="btn-groupcus-line d-flex">
        {listTimeRange.map(key => {
          const className =
            key === timeRangeFilter
              ? 'btn btn-cus-nomal bg-b-color-3 active'
              : 'btn btn-cus-nomal bg-b-color-3';
          return (
            <a
              href="#"
              className={className}
              key={key}
              onClick={() => {
                changeTimeRange(key);
              }}
            >
              {
                <Translate
                  value={`marketCalendarCorporate.tab.${listTimeRangeByKey[key].key}`}
                />
              }
            </a>
          );
        })}
      </div>
    );
  };

  render() {
    const { timeRangeFilter, dateRangeOption, setDateRangeOption } = this.props;
    return (
      <>
        <div className="filter-time-range d-flex mt-8">
          <div className="d-flex">
            {this.renderLeftFilterDayRange()}
            <PopupCalendar
              timeRangeFilter={timeRangeFilter}
              setDateRangeOption={setDateRangeOption}
              dateRangeOption={dateRangeOption}
            />
          </div>
        </div>
        {this.renderInfoFilterDayRange()}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    timeRangeFilter: state[REDUCER_NAME].timeRangeFilter,
    currentFilterEvents: state[REDUCER_NAME].currentFilterEvents,
    dateRangeOption: state[REDUCER_NAME].dateRangeOption,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeTimeRange: key => dispatch(changeTimeRange(key)),
    setDateRangeOption: (fromDate, toDate) =>
      dispatch(setDateRangeOption(fromDate, toDate)),
    resetDateRangeOption: () => dispatch(resetDateRangeOption()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterTime);
